"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localeMiddleware = void 0;

var _sbLocalStorage = require("../services/sb-local-storage");

var _utils = require("./utils");

var _actions = require("./actions");

/**
 * Middleware for initializing language/locale.
 *
 * @name skybase-core.base.middlewares#initLocaleMiddleware
 *
 * @method
 */
var localeMiddleware = function localeMiddleware(store) {
  return function (next) {
    return function (action) {
      var type = action.type;

      var _ref = action.payload || {},
          language = _ref.language,
          culture = _ref.culture;

      switch (type) {
        // TODO: This could be removed in the future, once we are sure no project is using it
        case _actions.INIT_LANGUAGE:
          {
            // Try to determine actual user's locale:
            // First check if locale was set manually to local storage. If not, do browser locale detection.
            var detectedLanguage = (0, _sbLocalStorage.getItem)('language') || (0, _utils.getBrowserLocale)();
            store.dispatch((0, _actions.setLanguage)(detectedLanguage)); // Need to set the language here so that the login modal, etc can be translated

            (0, _sbLocalStorage.setItem)('language', language);
            break;
          }

        case _actions.SET_LANGUAGE:
          (0, _sbLocalStorage.setItem)('language', language);
          break;

        case _actions.INIT_CULTURE:
          {
            var detectedCulture = (0, _sbLocalStorage.getItem)('culture') || (0, _utils.getBrowserLocale)();
            store.dispatch((0, _actions.setCulture)(detectedCulture));
            break;
          }

        case _actions.SET_CULTURE:
          (0, _sbLocalStorage.setItem)('culture', culture);
          break;

        default:
          break;
      }

      return next(action);
    };
  };
};

exports.localeMiddleware = localeMiddleware;
//# sourceMappingURL=middlewares.js.map